var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1422_18764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4224 2.47168H1.3093C0.587344 2.47168 0 3.05902 0 3.78098V11.8904C0 12.6123 0.587344 13.1996 1.3093 13.1996H34.4224C35.1444 13.1996 35.7317 12.6123 35.7317 11.8904V3.78098C35.7318 3.05902 35.1445 2.47168 34.4224 2.47168ZM8.78516 11.9325H1.30938C1.28609 11.9325 1.26711 11.9136 1.26711 11.8903V3.7809C1.26711 3.75762 1.28602 3.73863 1.30938 3.73863H8.78516V11.9325ZM34.4647 11.8904C34.4647 11.9136 34.4458 11.9326 34.4224 11.9326H10.0522V3.73871H34.4224C34.4456 3.73871 34.4647 3.75762 34.4647 3.78098V11.8904Z",
    fill: "url(#paint0_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.61 5.85059H12.1218C11.7719 5.85059 11.4883 6.13426 11.4883 6.4841C11.4883 6.83395 11.772 7.11762 12.1218 7.11762H23.61C23.9599 7.11762 24.2435 6.83395 24.2435 6.4841C24.2435 6.13426 23.9599 5.85059 23.61 5.85059Z",
    fill: "url(#paint1_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7195 8.55371H18.2038C17.8538 8.55371 17.5703 8.83738 17.5703 9.18723C17.5703 9.53707 17.854 9.82074 18.2038 9.82074H31.7195C32.0694 9.82074 32.353 9.53707 32.353 9.18723C32.353 8.83738 32.0693 8.55371 31.7195 8.55371Z",
    fill: "url(#paint2_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5009 8.55371H12.1218C11.7719 8.55371 11.4883 8.83738 11.4883 9.18723C11.4883 9.53707 11.772 9.82074 12.1218 9.82074H15.5009C15.8508 9.82074 16.1344 9.53707 16.1344 9.18723C16.1344 8.83738 15.8507 8.55371 15.5009 8.55371Z",
    fill: "url(#paint3_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02609 4.49902C3.74516 4.49902 2.70312 5.54113 2.70312 6.82199C2.70312 7.17191 2.9868 7.45551 3.33664 7.45551C3.68648 7.45551 3.97016 7.17184 3.97016 6.82199C3.97016 6.23973 4.44383 5.76605 5.02609 5.76605C5.60836 5.76605 6.08203 6.2398 6.08203 6.82199C6.08203 7.40418 5.60836 7.87793 5.02609 7.87793C4.67617 7.87793 4.39258 8.1616 4.39258 8.51145C4.39258 8.86129 4.67625 9.14496 5.02609 9.14496C6.30703 9.14496 7.34906 8.10293 7.34906 6.82199C7.34906 5.54105 6.30703 4.49902 5.02609 4.49902Z",
    fill: "url(#paint4_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03141 9.90527H5.02469C4.67477 9.90527 4.39453 10.1889 4.39453 10.5388C4.39453 10.8886 4.68156 11.1723 5.03148 11.1723C5.38141 11.1723 5.665 10.8886 5.665 10.5388C5.665 10.1889 5.38125 9.90527 5.03141 9.90527Z",
    fill: "url(#paint5_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.61 18.0146H12.1218C11.7719 18.0146 11.4883 18.2983 11.4883 18.6482C11.4883 18.998 11.772 19.2817 12.1218 19.2817H23.61C23.9599 19.2817 24.2435 18.998 24.2435 18.6482C24.2435 18.2983 23.9599 18.0146 23.61 18.0146Z",
    fill: "url(#paint6_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6921 20.7178H18.2038C17.8539 20.7178 17.5703 21.0014 17.5703 21.3513C17.5703 21.7011 17.854 21.9848 18.2038 21.9848H29.6921C30.042 21.9848 30.3256 21.7011 30.3256 21.3513C30.3256 21.0014 30.042 20.7178 29.6921 20.7178Z",
    fill: "url(#paint7_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5009 20.7178H12.1218C11.7719 20.7178 11.4883 21.0014 11.4883 21.3513C11.4883 21.7011 11.772 21.9848 12.1218 21.9848H15.5009C15.8508 21.9848 16.1344 21.7011 16.1344 21.3513C16.1344 21.0014 15.8507 20.7178 15.5009 20.7178Z",
    fill: "url(#paint8_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02609 16.6631C3.74516 16.6631 2.70312 17.7051 2.70312 18.9861C2.70312 19.336 2.9868 19.6196 3.33664 19.6196C3.68648 19.6196 3.97016 19.3359 3.97016 18.9861C3.97016 18.4038 4.44383 17.9301 5.02609 17.9301C5.60836 17.9301 6.08203 18.4038 6.08203 18.9861C6.08203 19.5683 5.60836 20.042 5.02609 20.042C4.67617 20.042 4.39258 20.3257 4.39258 20.6755C4.39258 21.0254 4.67625 21.309 5.02609 21.309C6.30703 21.309 7.34906 20.267 7.34906 18.9861C7.34906 17.7051 6.30703 16.6631 5.02609 16.6631Z",
    fill: "url(#paint9_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03141 22.0693H5.02469C4.67477 22.0693 4.39453 22.353 4.39453 22.7029C4.39453 23.0527 4.68156 23.3364 5.03148 23.3364C5.38141 23.3364 5.665 23.0527 5.665 22.7029C5.665 22.353 5.38125 22.0693 5.03141 22.0693Z",
    fill: "url(#paint10_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.61 30.1787H12.1218C11.7719 30.1787 11.4883 30.4624 11.4883 30.8122C11.4883 31.1621 11.772 31.4457 12.1218 31.4457H23.61C23.9599 31.4457 24.2435 31.1621 24.2435 30.8122C24.2435 30.4624 23.9599 30.1787 23.61 30.1787Z",
    fill: "url(#paint11_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3679 32.8818H18.2038C17.8539 32.8818 17.5703 33.1655 17.5703 33.5153C17.5703 33.8652 17.854 34.1489 18.2038 34.1489H30.3679C30.7178 34.1489 31.0014 33.8652 31.0014 33.5153C31.0014 33.1655 30.7177 32.8818 30.3679 32.8818Z",
    fill: "url(#paint12_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5009 32.8818H12.1218C11.7719 32.8818 11.4883 33.1655 11.4883 33.5153C11.4883 33.8652 11.772 34.1489 12.1218 34.1489H15.5009C15.8508 34.1489 16.1344 33.8652 16.1344 33.5153C16.1344 33.1655 15.8507 32.8818 15.5009 32.8818Z",
    fill: "url(#paint13_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02609 28.8271C3.74516 28.8271 2.70312 29.8692 2.70312 31.1501C2.70312 31.5 2.9868 31.7836 3.33664 31.7836C3.68648 31.7836 3.97016 31.5 3.97016 31.1501C3.97016 30.5679 4.44383 30.0942 5.02609 30.0942C5.60836 30.0942 6.08203 30.5679 6.08203 31.1501C6.08203 31.7324 5.60836 32.2061 5.02609 32.2061C4.67617 32.2061 4.39258 32.4897 4.39258 32.8396C4.39258 33.1894 4.67625 33.4731 5.02609 33.4731C6.30703 33.4731 7.34906 32.4311 7.34906 31.1501C7.34906 29.8693 6.30703 28.8271 5.02609 28.8271Z",
    fill: "url(#paint14_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03141 34.2334H5.02469C4.67477 34.2334 4.39453 34.5171 4.39453 34.8669C4.39453 35.2168 4.68156 35.5004 5.03148 35.5004C5.38141 35.5004 5.665 35.2168 5.665 34.8669C5.665 34.5171 5.38125 34.2334 5.03141 34.2334Z",
    fill: "url(#paint15_linear_1422_18764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.973 28.5056C40.0404 28.2821 39.9795 28.0397 39.8145 27.8747L35.7317 23.792V15.945C35.7317 15.2231 35.1444 14.6357 34.4224 14.6357H1.3093C0.587344 14.6357 0 15.2231 0 15.945V24.0544C0 24.7764 0.587344 25.3637 1.3093 25.3637H31.7616V26.7997H1.3093C0.587344 26.7997 0 27.3871 0 28.1091V36.2185C0 36.9404 0.587344 37.5278 1.3093 37.5278H34.4224C35.1444 37.5278 35.7317 36.9404 35.7317 36.2185V34.277L36.3227 35.7037C36.387 35.8589 36.5102 35.9823 36.6656 36.0466C36.7432 36.0787 36.8256 36.0948 36.908 36.0948C36.9903 36.0948 37.0727 36.0788 37.1504 36.0466L39.4236 35.105C39.7469 34.9711 39.9004 34.6004 39.7665 34.2772L37.7069 29.305L39.492 28.9437C39.7209 28.8974 39.9057 28.729 39.973 28.5056ZM8.78516 24.0967H1.30938C1.28609 24.0967 1.26711 24.0778 1.26711 24.0544V15.945C1.26711 15.9218 1.28602 15.9028 1.30938 15.9028H8.78516V24.0967ZM10.0522 24.0967V15.9029H34.4224C34.4457 15.9029 34.4647 15.9218 34.4647 15.9451V22.525L32.843 20.9034C32.6619 20.7221 32.3893 20.668 32.1527 20.7661C31.9159 20.8641 31.7616 21.0952 31.7616 21.3514V24.0968L10.0522 24.0967ZM8.78516 36.2607H1.30938C1.28609 36.2607 1.26711 36.2418 1.26711 36.2184V28.1091C1.26711 28.0858 1.28602 28.0668 1.30938 28.0668H8.78516V36.2607ZM34.4647 36.2184C34.4647 36.2417 34.4458 36.2607 34.4224 36.2607H10.0522V28.0668H31.7616V31.1932C31.7616 31.426 31.8892 31.64 32.094 31.7507C32.2988 31.8613 32.5477 31.8507 32.7424 31.7232L34.2616 30.7275L34.4647 31.2179V36.2184ZM36.7016 28.2157C36.516 28.2532 36.357 28.3718 36.268 28.5389C36.179 28.7061 36.1695 28.9042 36.2419 29.0792L38.3534 34.1768L37.2509 34.6336L35.1394 29.5359C35.0672 29.3615 34.921 29.2285 34.7407 29.1729C34.6795 29.1541 34.6167 29.1448 34.5542 29.1448C34.4322 29.1448 34.3113 29.18 34.2069 29.2485L33.0288 30.0207V22.8809L38.084 27.9361L36.7016 28.2157Z",
    fill: "url(#paint16_linear_1422_18764)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1422_18764",
    x1: -2.63724e-7,
    y1: 2.78876,
    x2: 14.8842,
    y2: 26.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1422_18764",
    x1: 11.4883,
    y1: 5.88804,
    x2: 12.2677,
    y2: 9.61932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1422_18764",
    x1: 17.5703,
    y1: 8.59116,
    x2: 18.2501,
    y2: 12.3627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1422_18764",
    x1: 11.4883,
    y1: 8.59116,
    x2: 13.1688,
    y2: 11.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1422_18764",
    x1: 2.70312,
    y1: 4.63634,
    x2: 8.24082,
    y2: 7.26961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1422_18764",
    x1: 4.39453,
    y1: 9.94272,
    x2: 5.90734,
    y2: 10.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1422_18764",
    x1: 11.4883,
    y1: 18.0521,
    x2: 12.2677,
    y2: 21.7834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1422_18764",
    x1: 17.5703,
    y1: 20.7552,
    x2: 18.3498,
    y2: 24.4865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1422_18764",
    x1: 11.4883,
    y1: 20.7552,
    x2: 13.1688,
    y2: 23.6855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1422_18764",
    x1: 2.70312,
    y1: 16.8004,
    x2: 8.24082,
    y2: 19.4337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1422_18764",
    x1: 4.39453,
    y1: 22.1068,
    x2: 5.90734,
    y2: 22.8281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1422_18764",
    x1: 11.4883,
    y1: 30.2162,
    x2: 12.2677,
    y2: 33.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1422_18764",
    x1: 17.5703,
    y1: 32.9193,
    x2: 18.3136,
    y2: 36.6659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1422_18764",
    x1: 11.4883,
    y1: 32.9193,
    x2: 13.1688,
    y2: 35.8496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1422_18764",
    x1: 2.70312,
    y1: 28.9645,
    x2: 8.24082,
    y2: 31.5977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1422_18764",
    x1: 4.39453,
    y1: 34.2708,
    x2: 5.90734,
    y2: 34.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1422_18764",
    x1: -2.95227e-7,
    y1: 15.3124,
    x2: 34.5832,
    y2: 44.0471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_18764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.b80b29290a7f11ccade0ecd5fc88e74c.svg";
export { ForwardRef as ReactComponent };